import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { data } from "react-router";

import { getExtensivePromotionById } from "~/core/deprecated/extensive-promotions";
import { getTopperBannerById } from "~/core/deprecated/header-banner";
import { getSpecialOffers } from "~/core/deprecated/special-offers";
import { PromoDescription } from "~/features/promo-description/PromoDescription";
import type { AccordionProps } from "~/features-deprecated/accordion/Accordion";
import { Accordion } from "~/features-deprecated/accordion/Accordion";
import { TopperWithoutReg } from "~/features-deprecated/banner/TopperWithoutReg";
import { PromoPageSteps } from "~/features-deprecated/promoPageSteps/PromoPageSteps";
import { SpecialOffers } from "~/features-deprecated/special-offers/SpecialOffers";
import { Stripe } from "~/features-deprecated/stripe/Stripe";
import { StripeWrapper } from "~/shared/ui-kit/stripe-wrapper/StripeWrapper";
import { getAffCookie, makePlayNowUrl } from "~/shared/utils/aff-integration";
import { useGtmContext } from "~/shared/utils/gtm-sdk/provider";

import type { Route } from "./+types/$lang.series";

const accordionData: AccordionProps = {
  data: [
    {
      title: { zh: "Terms and conditions", en: "Terms and conditions" },
      description: {
        zh: `- Winning a Lucky Pass package allows you to choose between various land-based events listed on LINK/URL. Do not play the satellites if you are unsure whether you can travel to any of the listed events or not. 
- The package value cannot be exchanged/reimbursed for money and/or tickets, however you are free to transfer your win to another Lucky  Poker registered player if that person fulfils the criterias listed below. 
- Packages will always include; 1 (one) buy-in to the Main Event (or other named side-event), accommodation for 1 (one) or 2 (two) persons on pre announced dates. In some cases a package can include a merchandise kit that may be handed over at the venue or sent to the winners registered address. The package holder must wear Lucky  Poker merchandise when playing the tournament, where appropriate 
- Packages will always include; 1 (one) buy-in to the Main Event (or other named side-event), accommodation for 1 (one) or 2 (two) persons on pre announced dates. In some cases a package can include a merchandise kit that may be handed over at the venue or sent to the winners registered address. The package holder must wear Lucky  Poker merchandise when playing the tournament, where appropriate `,
        en: `- Winning a Lucky Pass package allows you to choose between various land-based events listed on LINK/URL. Do not play the satellites if you are unsure whether you can travel to any of the listed events or not. 
- The package value cannot be exchanged/reimbursed for money and/or tickets, however you are free to transfer your win to another Lucky  Poker registered player if that person fulfils the criterias listed below. 
- Packages will always include; 1 (one) buy-in to the Main Event (or other named side-event), accommodation for 1 (one) or 2 (two) persons on pre announced dates. In some cases a package can include a merchandise kit that may be handed over at the venue or sent to the winners registered address. The package holder must wear Lucky  Poker merchandise when playing the tournament, where appropriate 
- Packages will always include; 1 (one) buy-in to the Main Event (or other named side-event), accommodation for 1 (one) or 2 (two) persons on pre announced dates. In some cases a package can include a merchandise kit that may be handed over at the venue or sent to the winners registered address. The package holder must wear Lucky  Poker merchandise when playing the tournament, where appropriate  `,
      },
      id: 1,
    },
  ],
};

export const loader = async ({
  request,
  context: { featureFlags },
}: Route.LoaderArgs) => {
  if (!featureFlags.getItem("fullSeriesPage").enabled) {
    throw new Response("Not Found", { status: 404, statusText: "Not Found" });
  }

  return data(
    {
      affiliate: await getAffCookie(request),
      topperBanner: getTopperBannerById("series"),
      specialOffers: getSpecialOffers(),
      extensivePromotion: getExtensivePromotionById("series"),
      featureFlags: {
        isSpecialOffersButtonEnabled: featureFlags.getItem(
          "specialOffersButton",
        ).enabled,
        isSupportIconsEnabled:
          featureFlags.getItem("supportIconsBlock").enabled,
        isAccordionEnabled: featureFlags.getItem("seriesPageAccordion").enabled,
      },
    },
    {
      headers: {
        "Cache-Control": "public, max-age=30000",
      },
    },
  );
};

export function headers({
  loaderHeaders,
  actionHeaders,
}: Route.HeadersArgs): Headers {
  return loaderHeaders ?? actionHeaders;
}

const Page: FC<Route.ComponentProps> = function ({
  loaderData: {
    specialOffers,
    featureFlags,
    extensivePromotion,
    topperBanner,
    affiliate,
  },
}) {
  const {
    t,
    i18n: { language },
  } = useTranslation("home");
  const { t: tSeries } = useTranslation("series");
  const { gtm } = useGtmContext();
  return (
    <div className="main-page series">
      <TopperWithoutReg
        topperTitle={topperBanner.topperTitle[language]}
        isMainTopper={topperBanner.isMain}
        playNowLink={makePlayNowUrl(affiliate)}
        topperBackground={{
          imageVariants: topperBanner.imageDesktop[language],
          mobileImageVariants: topperBanner.imageMobile[language],
        }}
        analytics={{
          createAccountMain() {
            gtm.createAccountMain({
              eventTime: new Date(),
              playerID: null,
              screenName: "mainPage",
            });
          },
          logInMain() {
            gtm.logInMain({
              eventTime: new Date(),
              playerID: null,
              screenName: "mainPage",
            });
          },
        }}
      />
      <StripeWrapper variant="secondary">
        <Stripe title={tSeries("support.stripe.heading.title")} />
      </StripeWrapper>
      <PromoDescription data={extensivePromotion} lang={language} />
      <StripeWrapper variant="tertiary">
        <PromoPageSteps
          firstStepText={t("steps.text.registration")}
          secondStepText={t("steps.text.game")}
          thirdStepText={t("steps.text.rewards")}
          playNowText={t("steps.button.play")}
          playNowLink={makePlayNowUrl(affiliate)}
          analytics={{
            playNow() {
              gtm.playNow({
                eventTime: new Date(),
                playerID: null,
                screenName: "mainPage",
              });
            },
          }}
        />
      </StripeWrapper>
      <SpecialOffers
        featureFlags={featureFlags}
        specialOffers={specialOffers}
      />
      {featureFlags.isAccordionEnabled && (
        <Accordion data={accordionData.data} />
      )}
    </div>
  );
};

export default Page;
